module.exports = __webpack_public_path__ + "static/media/mongodb.81ab19f0.png";